import React from 'react';
import type { TranslationFn } from '@mentimeter/question-modules-types';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';
import { ErrorIcon } from './assets/ErrorIcon';

export type GroupingErrorType = 'something-went-wrong' | 'ai-disabled';
export interface GroupingErrorProps {
  onGoBack?: () => void;
  onClick: () => void;
  buttonText: string;
  errorType: GroupingErrorType;
  translationFn: TranslationFn;
}

export const GroupingError = ({
  onGoBack,
  onClick,
  buttonText,
  errorType,
  translationFn,
}: GroupingErrorProps) => {
  return (
    <Box
      p={5}
      bg="bgStrong"
      borderRadius="40px"
      m="auto"
      flexDirection="column"
      alignItems="center"
    >
      <ErrorIcon />
      {errorType === 'ai-disabled' ? (
        <>
          <Text color="text" fontWeight="semiBold" fontSize={6} my={2}>
            {translationFn('open.ai_unavailable')}
          </Text>
          <Text color="text" fontSize={5} my={2} textAlign="center">
            {translationFn('open.ai_no_access')}
            <br />
            {translationFn('open.contact_support')}
          </Text>
        </>
      ) : (
        <>
          <Box my={3}>
            <Text color="text" fontWeight="semiBold" fontSize={6}>
              {translationFn('open.unknown_error')}
            </Text>
          </Box>

          <Box>
            <Button
              px={3}
              py={2}
              variant="primary"
              onClick={onClick}
              extend={() => ({ height: 'unset' })}
              size="large"
            >
              {buttonText}
            </Button>
          </Box>
        </>
      )}
      <Clickable pt={5} onClick={onGoBack}>
        <Text fontSize={3} fontWeight="semiBold" color="primary">
          {translationFn('open.go_back_to_responses')}
        </Text>
      </Clickable>
    </Box>
  );
};
